export function computeR2(points: { x: number; y: number }[]): number {
  const n = points.length;
  if (n === 0) return NaN;

  const xMean = points.reduce((sum, p) => sum + p.x, 0) / n;
  const yMean = points.reduce((sum, p) => sum + p.y, 0) / n;

  let ssTot = 0;
  let ssRes = 0;

  for (const p of points) {
    const yPred = yMean + ((p.x - xMean) * (points.reduce((acc, pt) => acc + (pt.x - xMean) * (pt.y - yMean), 0)) /
      points.reduce((acc, pt) => acc + (pt.x - xMean) ** 2, 0));

    ssTot += (p.y - yMean) ** 2;
    ssRes += (p.y - yPred) ** 2;
  }

  return 1 - ssRes / ssTot;
}
